import { connect } from 'react-redux'
import ConversationHeader from 'components/ConversationHeader'
import { selectIsRightSidebarCollapsed } from 'selectors/app/selectIsRightSidebarCollapsed'
import {
  selectRoomFromUrl,
  selectRoomFromUrlIsExpired,
  selectRoomFromUrlExpiresAt,
} from 'ducks/chat/selectors/rooms'
import { selectAssignmentAgentNameForRoomFromUrl } from 'ducks/chat/selectors/assignment'
import { selectChannelIdFromUrl } from 'ducks/widgets/selectors/widgets'
import {
  doToggleRoomState,
  doStarRoom,
  doUnStarRoom,
  doSetRoomStateToClosed,
  doSetRoomStateToSpam,
  doSetRoomStateToOpen,
  doSetRoomStateToSnoozed,
  doSetRoomStateToTrash,
  doDeleteRoom,
  doOpenNextRoomPage,
  doOpenPreviousRoomPage,
} from 'ducks/chat/actions/rooms'
import BackButton from './Buttons/BackButton'
import PagingButtons from './Buttons/PagingButtons'
import AssignmentButton from './Buttons/AssignmentButton'
import CollectionButton from './Buttons/CollectionButton'

const select = state => {
  const room = selectRoomFromUrl(state)
  const currentChannelId = selectChannelIdFromUrl(state)
  const isExpired = selectRoomFromUrlIsExpired(state)
  const expiresAt = selectRoomFromUrlExpiresAt(state)

  return {
    conversationId: room.id,
    isAssigned: room.isAssigned,
    assignmentAgentName: selectAssignmentAgentNameForRoomFromUrl(state),
    assignedGroupId: room.assignedTeamId,
    isEditingTitle: false,
    isRightSidebarCollapsed: selectIsRightSidebarCollapsed(state),
    isStarred: room.isStarred,
    is3ColumnView: false,
    isSnoozed: room.isSnoozed,
    stateLabel: room.state,
    isCloseable: room.isCloseable,
    isDeleted: room.isDeleted,
    isSpam: room.isSpam,
    isExpired,
    expiresAt,
    snoozedUntil: room.snoozedUntil,
    PagingButtons,
    BackButton,
    AssignmentButton,
    CollectionButton,
    disableMerge: true,
    disableTags: true,
    disableStar: true,
    disableMore: true,
    disableCollection: !!currentChannelId,
  }
}

function toggleRoomState(roomId, stateLabel) {
  return doToggleRoomState(roomId, { state: stateLabel })
}

function setRoomStateToSnoozed(roomId, snoozedUntil = null) {
  return doSetRoomStateToSnoozed(roomId, { snoozedUntil })
}

const perform = {
  onToggleState: toggleRoomState,
  onClose: doSetRoomStateToClosed,
  onSpam: doSetRoomStateToSpam,
  onOpen: doSetRoomStateToOpen,
  onStar: doStarRoom,
  onUnstarred: doUnStarRoom,
  onSnooze: setRoomStateToSnoozed,
  onUnsnoozeAndOpen: doSetRoomStateToOpen,
  onSoftDelete: doSetRoomStateToTrash,
  onHardDelete: doDeleteRoom,
  onRestoreDeleted: doSetRoomStateToOpen,
  onRestoreSpam: doSetRoomStateToOpen,
  onOpenNextConversation: doOpenNextRoomPage,
  onOpenPreviousConversation: doOpenPreviousRoomPage,
}

export default connect(select, perform)(ConversationHeader)
